module.exports = __webpack_public_path__ + "img/icone-lupa.53328b90.svg";